import type { RequestCallbackParams } from './RequestCallback.types';
import type { DefaultResponse } from '@/shared/api';

// TODO: fix import from upper layer
import { serializeToFormData } from '@/app/plugins/http/http.utils';
import { BaseService, defineApi } from '@/shared/api';

class RequestCallbackService extends BaseService {
  async sendCallback(params: RequestCallbackParams): Promise<DefaultResponse> {
    const formData = serializeToFormData(params, false);
    return await this.post('/sendcallback', formData, {
      baseURL: import.meta.env.VUE_APP_API_LEGACY_URL ?? '/',
    });
  }
}

export const useRequestCallbackService = defineApi(RequestCallbackService);
